/**
 * Custom Logger Utility
 *
 * Only logs to console in development and QA environments.
 * Production logs are suppressed to improve performance and security.
 *
 * Usage:
 * import logger from '../utils/logger';
 *
 * logger.log('This will only show in dev/qa');
 * logger.error('Error message');
 * logger.warn('Warning message');
 * logger.info('Info message');
 * logger.debug('Debug message');
 */

const isDevelopment = ['dev', 'qa', 'development'].includes(process.env.REACT_APP_ENV) ||
                      process.env.NODE_ENV === 'development';

const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },

  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },

  table: (...args) => {
    if (isDevelopment) {
      console.table(...args);
    }
  },

  group: (...args) => {
    if (isDevelopment) {
      console.group(...args);
    }
  },

  groupEnd: () => {
    if (isDevelopment) {
      console.groupEnd();
    }
  },

  // Always log errors to console even in production (for error tracking)
  critical: (...args) => {
    console.error('[CRITICAL]', ...args);
  }
};

export default logger;
